import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgComponentFactoryComponent } from './pg-component-factory/pg-component-factory.component';
import { PgActionTextFactoryComponent } from './pg-action-text-factory/pg-action-text-factory.component';
import { GritCoreModule } from '../grit-core/grit-core.module';
import { PgTextContentFactoryComponent } from './pg-text-content-factory/pg-text-content-factory.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PgComponentFactoryComponent,
    PgActionTextFactoryComponent,
    PgTextContentFactoryComponent,
  ],
  exports: [
    PgComponentFactoryComponent,
    PgActionTextFactoryComponent,
    PgTextContentFactoryComponent,
  ],
  imports: [CommonModule, ReactiveFormsModule, GritCoreModule],
})
export class GritFactoryModule {}
